import styled from 'styled-components';
import { Flex } from '#atoms';
import Day from '../Day';
import TimePeriod from '../TimePeriod';
import { useRecoilState } from 'recoil';
import { sameStateAtom } from '../../Step6.atoms';

const DAYS = ['월', '화', '수', '목', '금', '토', '일'];

export default function SameSchedule() {
  const [sameState, setSameState] = useRecoilState(sameStateAtom);
  const onChangeStartAt = (index: number) => (date: Date) => {
    setSameState(prev => {
      const periods = [...prev.periods];
      periods[index] = { ...periods[index], startAt: date };
      return { ...prev, periods };
    });
  };
  const onChangeEndAt = (index: number) => (date: Date) => {
    setSameState(prev => {
      const periods = [...prev.periods];
      periods[index] = { ...periods[index], endAt: date };
      return { ...prev, periods };
    });
  };
  const handleAddTime = () => {
    setSameState(prev => ({
      ...prev,
      periods: [
        ...prev.periods,
        {
          startAt: undefined,
          endAt: undefined
        }
      ]
    }));
  };
  return (
    <>
      <DayWrapper gap={8}>
        {DAYS.map((day, index) => (
          <Day
            key={day}
            day={day}
            isSelected={sameState.days.includes(index)}
            style={{ height: '40px', width: '100%' }}
            onClick={() =>
              setSameState(prev => ({
                ...prev,
                days: prev.days.includes(index)
                  ? prev.days.filter(day => day !== index)
                  : [...prev.days, index]
              }))
            }
          />
        ))}
      </DayWrapper>
      <Flex gap={8} direction="column">
        <TimePeriod
          startAt={sameState.periods[0]?.startAt}
          endAt={sameState.periods[0]?.endAt}
          onChangeStartAt={onChangeStartAt(0)}
          onChangeEndAt={onChangeEndAt(0)}
        />
        {sameState.periods.map((period, index) => {
          if (index === 0) return null;

          const onRemove = () => {
            setSameState(prev => {
              const periods = [...prev.periods];
              periods.splice(index, 1);
              return { ...prev, periods };
            });
          };

          return (
            <TimePeriod
              hasDeletedIcon={index !== 0}
              startAt={period.startAt}
              endAt={period.endAt}
              onChangeStartAt={onChangeStartAt(index)}
              onChangeEndAt={onChangeEndAt(index)}
              onRemove={onRemove}
            />
          );
        })}
      </Flex>
      <Flex justify="flex-end" style={{ marginBottom: '56px' }}>
        <AddTime onClick={handleAddTime}>+ 시간 추가</AddTime>
      </Flex>
    </>
  );
}

const DayWrapper = styled(Flex)`
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.gray700};
`;

const AddTime = styled.span`
  margin-top: 8px;
  cursor: pointer;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.brand300};
  font-weight: 500;
`;
